<template>
  <div>
    <div class="login-header">
      <h2>{{ t('rolePickerTitle') }}</h2>
    </div>

    <p class="hint">{{ t('rolePickerHint') }}</p>

    <div class="role-buttons">
      <button class="role-btn role-admin" @click="$emit('pick', 'admin')">
        <div class="role-label">{{ t('roleDomainAdmin') }}</div>
        <div class="role-sub">{{ t('roleDomainAdminHint') }}</div>
      </button>

      <button class="role-btn role-client" @click="$emit('pick', 'client')">
        <div class="role-label">{{ t('roleClientUser') }}</div>
        <div class="role-sub">{{ t('roleClientUserHint') }}</div>
      </button>
    </div>

    <div class="link-row">
      <a href="#" class="forgot-link" @click.prevent="$emit('cancel')">{{ t('logout') }}</a>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { useI18n } from '../i18n/index.js'

export default defineComponent({
  name: 'RolePickerView',
  emits: ['pick', 'cancel'],
  setup() {
    const { t } = useI18n()
    return { t }
  }
})
</script>

<style scoped>
.login-header {
  margin-bottom: 12px;
}
.login-header h2 { margin: 0; font-size: 1.25rem; }

.hint { color: #6b7280; font-size: 14px; margin: 0 0 16px 0; }

.role-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.role-btn {
  padding: 16px;
  background: white;
  color: #111827;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  cursor: pointer;
  text-align: left;
  font: inherit;
  transition: border-color .15s, background .15s;
}
.role-btn:hover { border-color: #2563eb; background: #eff6ff; }
.role-label { font-weight: 600; font-size: 16px; }
.role-sub   { color: #6b7280; font-size: 13px; margin-top: 4px; }

.link-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
.forgot-link {
  font-size: 13px;
  color: #6b7280;
  text-decoration: none;
}
.forgot-link:hover { color: #2563eb; text-decoration: underline; }
</style>
